import { render, staticRenderFns } from "./CommentForRatingProRetoucher.vue?vue&type=template&id=fc79b2b6&"
import script from "./CommentForRatingProRetoucher.vue?vue&type=script&lang=js&"
export * from "./CommentForRatingProRetoucher.vue?vue&type=script&lang=js&"
import style0 from "./CommentForRatingProRetoucher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports